import { CommissionContextDto, CommissionPaymentType } from '../sdk/sdk';

export function signedPaymentAmount(magnitude: number, sign: 'positive' | 'negative' | null): number | null {
  if (sign === null) {
    return null;
  }
  const absolute = Math.abs(magnitude);
  return sign === 'negative' ? -absolute : absolute;
}

export function magnitudeFromPercentOfCommission(percent: number, commissionTotal: number): number {
  return roundToTwoDecimals(Math.abs(commissionTotal) * (percent / 100));
}

export function percentOfCommissionFromMagnitude(magnitude: number, commissionTotal: number): number | null {
  const total = Math.abs(commissionTotal);
  if (total === 0) {
    return null;
  }
  return roundToTwoDecimals((magnitude / total) * 100);
}

function roundToTwoDecimals(value: number): number {
  return Math.round(value * 100) / 100;
}

export function defaultSignForType(type: CommissionPaymentType): 'positive' | 'negative' | null {
  switch (type) {
    case CommissionPaymentType.CancelledContract:
    case CommissionPaymentType.AccountsReceivableClawback:
      return 'negative';
    case CommissionPaymentType.Initial:
    case CommissionPaymentType.Final:
      return 'positive';
    case CommissionPaymentType.RescopeAdjustment:
      return null;
    default:
      return null;
  }
}

export type CommissionPhaseButton = 'initial' | 'final' | null;

export function phaseButtonToShow(context: CommissionContextDto | undefined): CommissionPhaseButton {
  if (context === undefined) return null;
  if (context.initialPaidAt == null) return 'initial';
  return context.finalPaidAt == null ? 'final' : null;
}
